// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"index__placeholder___1flkJ","feature":"index__feature___IQJrk","square":"index__square___2CrAJ","poster":"index__poster___1f0m9","standard":"index__standard___8pBo9"};